import React, { useState, useEffect } from 'react'
import CheckIcon from './CheckIcon'
import { GiStarsStack } from "react-icons/gi";
import VisDiv from '../../whitaijiFrontendLibrary/components/VisDiv';
import { IoIosInformationCircleOutline } from "react-icons/io";
import T from '../Translation';
import { generateMongoDBId } from '../../whitaijiFrontendLibrary/lib/utils';
import BlueButton from '../BlueButton';



const ChooseSongs = ({data}) => {

    const {concert, setConcert, songsData, hideTestButtons} = data

    return (
        <div style={{marginTop:"30px"}}>
            {!Array.isArray(songsData) ? [] : songsData?.map((song, index) => <SongPin key={index} data={{song, concert, setConcert, hideTestButtons}} />)}
        </div>
    )
}

export default ChooseSongs

export const SongPin = ({data}) => {
        const [showInfo, setShowInfo] = useState(false)
        const onInfoClick = (e) => {
            e.stopPropagation()
            setShowInfo(!showInfo)
        }
    const {song, concert, setConcert, hideTestButtons} = data   
    const concertSongs = !Array.isArray(concert?.songs) ? [] : concert?.songs
    const songInConcert = !Array.isArray(concertSongs) ? undefined : concertSongs.find((s) => s?.songTemplateId === song?._id)
    const isSongInConcert = !Array.isArray(concertSongs) ? false : concertSongs.some((s) => s?.songTemplateId === song?._id)
    const isSongArchived = !Array.isArray(concertSongs) ? false : concertSongs.some((s) => s?.songTemplateId === song?._id && s?.status === "archived")

    const archivedSong = {title: song?.title, _id: songInConcert?._id, songTemplateId: song?._id, lyrics: songInConcert?.lyrics || [], affirmation: songInConcert?.affirmation || "", aiDescription: songInConcert?.aiDescription || "", status: "archived"}
    const activeSong = {title: song?.title, _id: songInConcert?._id, songTemplateId: song?._id, lyrics: songInConcert?.lyrics || [], affirmation: songInConcert?.affirmation || "", aiDescription: songInConcert?.aiDescription || "", status: "active"}

    const onClickPin = () => {
        if(!isSongInConcert) {
            const newSongs = [...concertSongs, {title: song?.title, _id: generateMongoDBId(), songTemplateId: song?._id, affirmation:"", lyrics: [], status: "active"}]
            setConcert({...concert, songs: newSongs})
        }
        if(isSongInConcert && !isSongArchived) {
            const newSongs = [...concertSongs?.filter((s) => s?.songTemplateId !== song?._id), archivedSong]
            setConcert({...concert, songs: newSongs})
        }
        if(isSongInConcert && isSongArchived) {
            const newSongs = [...concertSongs?.filter((s) => s?.songTemplateId !== song?._id), activeSong]
            setConcert({...concert, songs: newSongs})
        }
    }
    const testFunction = (e) => {
        e.stopPropagation()
        process.env.NODE_ENV === "development" && console.log("testFunction", {song, concert, songInConcert, isSongInConcert, concertSongs, isSongArchived })
    }
    
    return (
        <div style={{margin:"10px", borderBottom:"1px solid #c0bfbf", borderTop:"1px solid #c0bfbf"}}>
            <div style={{ display:"flex", alignItems:"center", padding:"10px"}}>
                <div onClick={onClickPin} style={{marginRight:"10px", cursor:"pointer"}}>
                    <CheckIcon status={isSongInConcert && !isSongArchived}/>
                </div>        
                <div>
                    {song?.title}
                </div>
                <VisDiv onClick={onInfoClick} style={{marginLeft:"10px", cursor:"pointer"}} rules={[songInConcert?.aiDescription]}>
                    <IoIosInformationCircleOutline size={25}/>
                </VisDiv>
                <VisDiv rules={[false]}>
                    <BlueButton fn={testFunction} hide={false} text={"Test Song"}></BlueButton>
                </VisDiv>
            </div>
            <VisDiv style={{marginBottom:"10px", border:"1px dotted #ccc", marginLeft:"30px", padding:"10px", color:"gray"}} rules={[showInfo]}>
                <div style={{marginBottom:"10px", display:"flex", alignItems:"center"}}>
                    <div style={{marginRight:"10px"}}>
                    <GiStarsStack size={18}/>
                    </div>
                    <div style={{fontWeight:"bold"}}>
                        <T obj={{en:"reMind ai says:", it: "reMind ia spiega:"}}/>
                    </div>
                    
                </div>
                <p>{songInConcert?.aiDescription}</p>
            </VisDiv>
            
        </div>
    )
}
